export const findPlaceMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Place>,
  placeId: string,
): uui.domain.ui.map.markers.Place | undefined => {
  const marker = markers[placeId]

  return marker
}
